/* NW sengeguide: gem anbefalingen i favoritter. Tilfoejet 31-08-2026.

   HVORFOR: guiden sluttede blindt. Kunden svarede paa seks spoergsmaal, fik en
   anbefaling, og havde derefter kun to veje videre: koeb nu, eller faa den paa mail.
   Var man ikke klar til nogen af delene, var arbejdet tabt. Favoritlisten er allerede
   bygget, delbar og synlig i headeren, saa den er det rigtige sted at parkere en
   anbefaling man vil vende tilbage til.

   HVAD DER GEMMES: hele det sammensatte saet, ikke kun dynebetraekket. Det er det samme
   som "Laeg i kurv" ville laegge i, bortset fra vaskemiddel og vaskepose. En favoritliste
   er til det man er ved at beslutte sig for, og vaskemiddel er et impulskoeb ved kassen.
   Antallet siges hoejt i kvitteringen, saa forskellen ikke overrasker.

   PLACERING: deler linje med mail-linket under bundbjaelken, saa bjaelken ikke bliver
   hoejere paa mobil. Mads meldte 31/8 at linjen var svaer at se paa desktop, hvor
   bjaelken er bred og teksten laa som lille graa bundtekst. Hjerteikon og sage-farve
   tilfoejet, saa den laeses som en handling og ikke som det med smaat. Mobil var
   allerede fin og aendrer sig kun i farve.

   HVORFOR EGEN VARIANTOPSLAG: nw-sg-priser.js har window.nwSgVariant, men den returnerer
   null hvis produktet ikke naaede at blive hentet. Samme kaploeb kostede os en tavs fejl i
   nw-sg-kurv.js. Her henter vi selv og venter paa svaret. De ~20 linjer er bevidst duplikeret. */
(function(){
  'use strict';

  var PUDE_H = 'bambus-hovedpude-vile';
  var DYNE_H = { embla: 'bambusdyne', silkebom: 'silkedyne-med-bomuldsvar', silkesilke: 'dyne' };
  var HJERTE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21.2l7.8-7.7 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  var cache = {};
  var hooket = false;

  function norm(s){ return String(s || '').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, '').replace(/cm/g, ''); }

  function hentProdukt(h){
    if(!h){ return Promise.resolve(null); }
    if(cache[h]){ return Promise.resolve(cache[h]); }
    return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ cache[h] = p; return p; })
      .catch(function(){ return null; });
  }

  function findVariant(p, st){
    if(!p || !p.variants){ return null; }
    var n = norm(st), i, j;
    for(i = 0; i < p.variants.length; i++){
      var o = p.variants[i].options || [];
      for(j = 0; j < o.length; j++){ if(norm(o[j]) === n){ return p.variants[i]; } }
    }
    for(i = 0; i < p.variants.length; i++){
      if(norm(p.variants[i].title).indexOf(n) === 0){ return p.variants[i]; }
    }
    if(p.variants.length === 1){ return p.variants[0]; }
    return null;
  }

  function tilFavorit(handle, stoerrelse){
    return hentProdukt(handle).then(function(p){
      var v = findVariant(p, stoerrelse);
      if(!p || !v){ return null; }
      var img = v.featured_image && v.featured_image.url ? v.featured_image.url : (p.featured_image || '');
      return { v: v.id, h: p.handle, t: p.title, p: v.price, img: img, s: v.title || '' };
    });
  }

  function saettet(){
    var opgaver = [];
    try{
      var col = materials[chosen.mat].colors[chosen.color];
      opgaver.push(tilFavorit(col.handle, chosen.size));
    }catch(e){}

    try{
      if(chosen.lagen && chosen.lagen.on && window.nwSgTilvalg){
        var typ = (chosen.lagen.type === 'kuvert') ? 'kuvert' : 'box';
        var lh = (window.nwSgTilvalg.lagenHandles(chosen.mat, typ) || [])[chosen.lagen.ci || 0];
        if(lh){ opgaver.push(tilFavorit(lh, chosen.lagen.size || chosen.size)); }
      }
    }catch(e){}

    try{
      if(chosen.pb && chosen.pb.qty > 0 && window.nwSgTilvalg){
        var ph = (window.nwSgTilvalg.pbHandles(chosen.mat) || [])[chosen.pb.ci || 0];
        if(ph){ opgaver.push(tilFavorit(ph, chosen.pb.size || '60×63')); }
      }
    }catch(e){}

    try{
      if(chosen.pude && chosen.pude.qty > 0){ opgaver.push(tilFavorit(PUDE_H, '60×63')); }
    }catch(e){}

    try{
      if(chosen.dyne && chosen.dyne.on){
        var dh = DYNE_H[chosen.dyne.opt];
        if(dh){ opgaver.push(tilFavorit(dh, chosen.size)); }
      }
    }catch(e){}

    if(!opgaver.length){ return Promise.resolve([]); }
    return Promise.all(opgaver).then(function(a){ return a.filter(function(x){ return !!x; }); });
  }

  function spor(navn, data){
    try{ if(typeof window.gtag === 'function'){ window.gtag('event', navn, data || {}); } }catch(e){}
    try{
      if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function'){
        window.Shopify.analytics.publish(navn, data || {});
      }
    }catch(e){}
  }

  function gem(knap){
    if(!window.NWWishlist){ return; }
    knap.disabled = true;
    saettet().then(function(varer){
      var nye = 0;
      varer.forEach(function(x){ if(window.NWWishlist.add(x)){ nye++; } });

      spor('nw_guide_favorit', {
        antal_gemt: varer.length,
        antal_nye: nye,
        materiale: (function(){ try{ return chosen.mat; }catch(e){ return ''; } })(),
        value: (function(){
          try{
            var t = document.getElementById('bartotal');
            return Number(String(t.textContent).replace(/\./g, '').replace(/,/g, '.').replace(/[^0-9.]/g, '')) || 0;
          }catch(e){ return 0; }
        })(),
        currency: 'DKK'
      });

      knap.disabled = false;
      var ord = varer.length === 1 ? '1 vare' : varer.length + ' varer';
      knap.innerHTML = varer.length
        ? HJERTE + '<span>Gemt, ' + ord + '. <a href="/pages/oenskeseddel">Se dine favoritter</a></span>'
        : HJERTE + '<span>Kunne ikke gemme, prøv igen</span>';
      knap.classList.add('nw-sg-fav--gemt');
    }).catch(function(){
      knap.disabled = false;
      knap.innerHTML = HJERTE + '<span>Kunne ikke gemme, prøv igen</span>';
    });
  }

  function injicer(){
    var mail = document.getElementById('nw-email-link');
    if(!mail || document.getElementById('nw-sg-fav')){ return; }

    var rk = document.createElement('div');
    rk.id = 'nw-sg-fav-row';
    rk.className = 'nw-sg-fav-row';

    var fav = document.createElement('button');
    fav.type = 'button';
    fav.id = 'nw-sg-fav';
    fav.className = 'nw-sg-fav';
    fav.innerHTML = HJERTE + '<span>Gem sættet i favoritter</span>';
    fav.addEventListener('click', function(){ gem(fav); });

    var prik = document.createElement('span');
    prik.className = 'nw-sg-fav-sep';
    prik.textContent = '·';

    mail.parentNode.insertBefore(rk, mail);
    rk.appendChild(fav);
    rk.appendChild(prik);
    rk.appendChild(mail);
    mail.textContent = 'Få den på mail';
  }

  function stil(){
    if(document.getElementById('nw-sg-fav-css')){ return; }
    var s = document.createElement('style');
    s.id = 'nw-sg-fav-css';
    s.textContent =
      '#nwsg .nw-sg-fav-row{display:flex;align-items:center;justify-content:center;gap:10px;flex-wrap:wrap;padding:9px 12px 4px}' +
      '#nwsg .nw-sg-fav-row #nw-email-link{padding:0;width:auto;display:inline;font-size:13px}' +
      '#nwsg .nw-sg-fav{display:inline-flex;align-items:center;gap:6px;background:none;border:none;cursor:pointer;color:var(--sageDark);font-size:13px;font-weight:500;text-decoration:underline;text-underline-offset:3px;font-family:\'Inter\',sans-serif;padding:0}' +
      '#nwsg .nw-sg-fav svg{width:15px;height:15px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;flex-shrink:0}' +
      '#nwsg .nw-sg-fav:hover{color:var(--ink)}' +
      '#nwsg .nw-sg-fav[disabled]{opacity:.5;cursor:default}' +
      '#nwsg .nw-sg-fav--gemt{text-decoration:none}' +
      '#nwsg .nw-sg-fav--gemt svg{fill:currentColor}' +
      '#nwsg .nw-sg-fav--gemt a{color:var(--sageDark);text-decoration:underline}' +
      '#nwsg .nw-sg-fav-sep{color:var(--line);font-size:13px}';
    document.head.appendChild(s);
  }

  function kobl(){ stil(); injicer(); }

  function hook(){
    if(hooket || typeof window.renderResult !== 'function'){ return; }
    hooket = true;
    var f = window.renderResult;
    window.renderResult = function(){
      var r = f.apply(this, arguments);
      kobl();
      return r;
    };
  }

  kobl();
  hook();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ kobl(); hook(); }); }
  window.addEventListener('load', function(){ kobl(); hook(); });
  setTimeout(function(){ kobl(); hook(); }, 1500);
  setTimeout(function(){ kobl(); hook(); }, 3500);
})();